import { useContext } from 'react';
import { useIsInModal } from '~/context/srp/FilterMenuContext';
import ModalContext from '~/context/srp/ModalContext';

export default function useFilterMenuEventSource(
  isInModalOverride?: boolean
): 'composer' | 'page' | undefined {
  const isInModalFromContext = useIsInModal();
  const { filterModalOpenSource } = useContext(ModalContext);
  const isInModal = isInModalOverride ?? isInModalFromContext;

  if (!isInModal) return undefined;

  return filterModalOpenSource === 'composer' ? 'composer' : 'page';
}
